'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["wrapperProps", "icon"];
import PropTypes from 'prop-types';
import SVGTextIconStyle from './SVGTextIconStyle';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGIcon = props => {
  const {
      wrapperProps,
      icon
    } = props,
    innerProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(SVGTextIconStyle, Object.assign({}, innerProps, {
      children: icon
    }))
  }));
};
SVGIcon.propTyes = {
  wrapperProps: PropTypes.node,
  icon: PropTypes.string
};
export default SVGIcon;